export default {
  title: 'Karte hinzufügen',
  buttons: {
    save: 'Speichern',
  },
  feedback: {
    success: 'Karte erfolgreich gespeichert',
  },
};
